
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/tantrum-3-year-old",
      function () {
        return require("private-next-pages/blog/tantrum-3-year-old.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/tantrum-3-year-old"])
      });
    }
  